import reducer from "./checkoutSlice";

export default reducer;
